import React, { Component } from "react";
import "./style.scss";
import "./mobile.scss";
import {
  getMaskedPhoneNumber,
  GetMessageText,
  getToken,
  login,
  StringRegex,
  userDetails,
  validateNumber,
  validateUserPassword,
} from "../../utils";

import * as actionTypes from "../../store/actions/types";
import { openNotification } from "../../config/notification";
import * as user from "../../service/userApi";
import { connect } from "react-redux";
import { GetIcon } from "../../config/icon";
import {
  Button,
  CardNavigation,
  CheckBox,
  FilterColor_1,
  FilterColor_2,
  Input,
  JoinFormHeader,
  OtpResendTimer,
} from "../../components";
import {
  RiArrowLeftLine,
  RiArrowRightLine,
  RiArrowRightSLine,
  RiCheckLine,
} from "react-icons/ri";
import { onClickOpenUpdateMobileNo } from "../../store/actions/updateMobileNo";
import { UpdateMobileNo } from "../modal";

class ForgetPasswordComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isSuccess: false,
      wizardNo: 1,
      userId: null,
      tags: [],
      tag: null,
      otp: null,
      token: null,
      attempt: 0,
      termsAndCondition: true,
      formIsValid: false,
      viewPointWidth: 0,
      viewPointHeight: 0,
      displayOtpResend: false,
      isEnableLoginIn: false,
      isExistingUser: false,
      isFoundUser: false,
      formHeader: "Reset your Password",
      userType: 1,
      token: null,
      isLogo: true,
      timer: "00:00",
      userData: null,
      mobileNo: null,
      dataForm: {
        firstName: {
          key: "firstName",
          elementType: "input",
          elementConfig: {
            type: "text",
            placeholder: "Ex : damith",
          },
          value: "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
          label: "First Name",
        },
        mobileNo: {
          key: "mobileNo",
          elementType: "phoneNo",
          elementConfig: {
            type: "input",
            placeholder: "Ex : 715 986 461",
            minLength: "9",
            maxLength: "9",
          },
          value: "",
          validation: {
            required: true,
            maxLength: 9,
            mobileNo: true,
          },
          valid: false,
          touched: false,
          label: "Enter your Mobile No",
        },
        password: {
          key: "password",
          elementType: "input",
          elementConfig: {
            type: "password",
            placeholder: "*************",
          },
          value: "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
          label: "Password",
        },
        confirmPassword: {
          key: "confirmPassword",
          elementType: "input",
          elementConfig: {
            type: "password",
            placeholder: "Confirm password",
          },
          value: "",
          validation: {
            required: true,
            minLength: 5,
            confirmPassword: true,
          },
          valid: false,
          touched: false,
          label: "Confirm Password",
        },
        otpVerification: {
          key: "otpVerification",
          elementType: "input",
          elementConfig: {
            type: "text",
            placeholder: "0 0 0 0 0 0",
            minLength: "6",
            maxLength: "6",
          },
          value: "",
          validation: {
            required: true,
            minLength: 6,
            maxLength: 6,
          },
          valid: false,
          touched: false,
          label: "Enter 5 digit code here",
        },
      },
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({
      viewPointWidth: window.innerWidth,
      viewPointHeight: window.innerHeight,
    });
  }

  componentDidMount() {
    let token = getToken();
    let user = userDetails();
    console.log({ user }, { token });
    this.setState({ userId: user.userId, token: token });
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    // window.addEventListener('scroll', this.listenToScroll);
    window.addEventListener("scroll", this.handleOnScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
    window.removeEventListener("resize", this.updateWindowDimensions);
    // window.addEventListener('scroll', this.listenToScroll);
  }

  onClickGoToNext = (_wizardNo) => {
    this.setState({
      wizardNo: _wizardNo,
    });
  };

  //==== input Handle Change
  inputHandleChange = (event, inputIdentity) => {
    const updateSignUpForm = {
      ...this.state.dataForm,
    };
    const updatedFormElement = {
      ...updateSignUpForm[inputIdentity],
    };

    switch (inputIdentity) {
      case "mobileNo":
        this.setState({ isFoundUser: false });
        updatedFormElement.value = validateNumber(
          updatedFormElement.value,
          event.target.value.toString()
        );
        break;
      case "otpVerification":
        updatedFormElement.value = event.target.value;
        if (event.target.value.length === 6) {
          // this.setState({ wizardNo: 2 });

          this.sendVerify(
            this.state.userId,
            event.target.value,
            this.state.token
          );
        }
        break;
      default:
        updatedFormElement.value = event.target.value;
        break;
    }

    updatedFormElement.valid = this.checkValidity(
      updatedFormElement.value,
      updatedFormElement.validation
    );
    updatedFormElement.touched = true;
    updateSignUpForm[inputIdentity] = updatedFormElement;
    let formIsValid = true;
    for (let inputIdentifier in updateSignUpForm) {
      formIsValid = updateSignUpForm[inputIdentifier].valid && formIsValid;
    }
    this.setState({ dataForm: updateSignUpForm, formIsValid: formIsValid });
  };

  //=== validation
  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
      isValid = value.trim() !== "" && isValid;
    }
    if (rules.mobileNo) {
      isValid = true;
    }

    if (rules.email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(String(value).toLowerCase()) && isValid;
    }
    return isValid;
  }

  validation = (validationValue, inputIdentity) => {
    const updateSignUpForm = {
      ...this.state.dataForm,
    };
    const updatedFormElement = {
      ...updateSignUpForm[inputIdentity],
    };

    updatedFormElement.value = validationValue;
    updatedFormElement.valid = this.checkValidity(
      updatedFormElement.value,
      updatedFormElement.validation
    );
    updatedFormElement.touched = true;
    updateSignUpForm[inputIdentity] = updatedFormElement;
    let formIsValid = true;
    for (let inputIdentifier in updateSignUpForm) {
      formIsValid = updateSignUpForm[inputIdentifier].valid && formIsValid;
    }
    this.setState({ dataForm: updateSignUpForm, formIsValid: formIsValid });
  };

  async updateInputValidationErrors() {
    const { wizardNo, userType, termsAndCondition } = this.state;
    let df = { ...this.state.dataForm };
    let formIsValid = true;

    if (wizardNo === 2 && userType === 1) {
      for (let itemKey of Object.keys(df)) {
        if (itemKey === "password") {
          if (!validateUserPassword(df[itemKey].value)) {
            df[itemKey].touched = true;
            formIsValid = false;
          }
          if (df[itemKey].value === "") {
            df[itemKey].touched = true;
            df[itemKey].valid = false;
            formIsValid = false;
          }
        }
        if (itemKey === "confirmPassword") {
          if (df[itemKey].value === "") {
            df[itemKey].touched = true;
            df[itemKey].valid = false;
            formIsValid = false;
          }
        }
        if (df.password.value !== df.confirmPassword.value) {
          df[itemKey].invalidReason = GetMessageText("passwordNotMatch");
          formIsValid = false;
        }
      }
      this.setState({ dataForm: df, formIsValid: formIsValid });
    }

    return formIsValid;
  }

  onClickRightIcon(key) {
    let df = { ...this.state.dataForm };
    if (df[key].elementConfig.type === "password")
      df[key].elementConfig.type = "text";
    else df[key].elementConfig.type = "password";
    this.setState({ dataForm: df });
  }

  onClickGoBack = (wizardFormNo, userType) => {
    this.setState({ wizardNo: wizardFormNo, userType });
  };

  onClickAgreedTermsAndCondition() {
    this.setState({
      termsAndCondition: !this.state.termsAndCondition,
    });
  }

  fetchMobileNumber = (value) => {
    let newValue = value.replace("+", "");
    return (
      "+" + newValue.replace(/\d{8}$/, "") + newValue.replace(/^\d{8}/, "*****")
    );
  };

  async onOtpEnter(otp) {
    console.log("hue otp entered", otp);
    this.setState({ isEnableLoginIn: true, otp: otp });
  }

  async onOtpResend(userId, mobileNo, token) {
    this.setState({ isLoading: true });
    let res = await user.otpSend(userId, mobileNo, token);
    if (res && res.data && res.data.status) {
      this.setState({ isLoading: false, displayOtpResend: false });
    } else if (!res.data.status && res.data.data.attempt === 4) {
      openNotification({
        title: "Account blocked",
        message: res?.data?.message,
        type: "danger",
        container: "top-center",
      });
      this.props.history.push("/");
    } else {
      return false;
    }
  }

  onCountdownFinish() {
    this.setState({ displayOtpResend: true, isEnableLoginIn: false });
  }

  async sendVerify(userId, OTP) {
    this.setState({ isLoading: true, displayOtpResend: false });
    const token = getToken();
    let res = await user.otpVerify(userId, OTP, token);
    console.log("otpVerify:::", res);
    if (res && res.data && res.data.status) {
      console.log("sign in user:::", res.data.data);
      this.setState({
        isLoading: false,
        displayOtpResend: false,
        wizardNo: 2,
        token: res.data.data.token,
      });
      // login(res.data.data.token);
      // this.props.onAddLoginUser(res.data.data);
      // let user = userDetails();
      // this.props.onClickCloseOTPVerify();
      // if (user && user.userId) {
      //   this.props.history.push("/");
      // }
    } else {
      this.setState({ isLoading: false, displayOtpResend: false });
      //todo

      openNotification({
        title: "One time password",
        message: "Invalid authentication, Please check again OTP",
        type: "danger",
        container: "top-center",
      });
    }
  }

  async updateUserPassword() {
    this.setState({ isLoading: true });
    let df = { ...this.state.dataForm };
    let res = await user.updatePassword(this.state.userId, df.password.value);
    console.log("user", res);
    if (res && res.data && res.data.status) {
      this.props.history.push("/sign-in");
      this.props.setUserData(res.data.data);
    } else {
      this.setState({ isLoading: false });
    }
  }

  // async sendVerify(userId, OTP, token) {
  //   this.setState({ isLoading: true, displayOtpResend: false });
  //   let res = await user.otpVerify(userId, OTP, token);
  //   if (res && res.data && res.data.status) {
  //     console.log("sign in user:::", res.data.data);
  //     this.setState({ isLoading: false, displayOtpResend: false });
  //     login(res.data.token);
  //     this.props.onAddLoginUser(res.data.data);
  //     this.props.onClickCloseSignUp();
  //   } else {
  //     this.setState({ isLoading: false, displayOtpResend: false });
  //     openNotification({
  //       title: "One time password",
  //       message: "Invalid authentication, Please check again OTP",
  //       type: "danger",
  //       container: "top-center",
  //     });
  //   }
  // }

  async componentDidUpdate(prevProps, prevState) {
    // Check if bankIdList or categoryIdList have changed
    // if (prevProps.isOTPVerify !== this.props.isOTPVerify) {
    //   if (this.props.isOTPVerify) {
    //     this.setState({ wizardNo: 4 });
    //   } else {
    //     this.setState({ wizardNo: 1 });
    //   }
    // }
    if (prevProps.loginUserData !== this.props.loginUserData) {
      console.log("loginUserData", this.props.loginUserData);
      let newFormData = this.state.dataForm;
      newFormData["mobileNo"].value = this.props.loginUserData.mobileNo;
      this.setState({
        userData: this.props.loginUserData,
        dataForm: newFormData,
        token: this.props.loginUserToken,
      });
      console.log(this.state.dataForm);
    }
  }

  render() {
    const {
      dataForm,
      isLoading,
      isSuccess,
      viewPointHeight,
      viewPointWidth,
      userData,
      token,
      wizardNo,
      otp,
      isExistingUser,
      userType,
      isFoundUser,
      formHeader,
      isLogo,
      displayOtpResend,
      isUpdateMobileNo,
    } = this.state;
    const { loginUserData } = this.props;
    return (
      <>
        {/*<h1>Hi....</h1>*/}

        <UpdateMobileNo />
        <div className={"join-form-main-wrapper justify-content-md-center"}>
          <div className={"join-artworkTop"}>
            <img src={require("../../assets/img/join_artWork_top.svg")} />
          </div>
          <div className={"mobile-join-artworkTop"}>
            <img
              src={require("../../assets/img/mobile_join_artWork_top.svg")}
            />
          </div>
          <div>
            {isLoading && <div className={"loading-mask"} />}

            <div className={"new_join-form-wrapper"}>
              <JoinFormHeader
                isLogo={true}
                isBack={true}
                type={"reset"}
                mobileNo={dataForm.mobileNo.value}
                history={this.props.history}
                wizardNo={wizardNo}
                header={wizardNo === 1 ? "Verify Mobile Number" : formHeader}
                onClickUpdateMobileNo={() => {
                  this.props.onClickOpenUpdateMobileNo();
                }}
              />

              <div className={"join-form-action-section"}>
                <div className={"data-form-wrapper flex-row"}>
                  {/*------ wizard-2 set password -----------*/}
                  {this.state.wizardNo === 2 && (
                    <div className={"join-form-wizard-3"}>
                      <div className={"join-form-page-title mb-3"}>
                        Tell us about your purpose
                      </div>
                      <div className={"mb-3"}>
                        <CardNavigation
                          imgTag={
                            <img
                              className={"lading-bg"}
                              width={"42"}
                              height={"42"}
                              src={require("../../assets/img/Card/navigation/viwer.svg")}
                              alt="all offers in one place"
                            />
                          }
                          size={"lg"}
                          icon={<RiCheckLine />}
                          isState={true}
                          // onClick={() => this.onClickGoToNext(2, 1)}
                          text={"I want to see offers"}
                          title={"Account verified"}
                        />
                      </div>
                      <div className={"data-form-wrapper flex-row "}>
                        <Input
                          elementConfig={dataForm.password.elementConfig}
                          elementType={dataForm.password.elementType}
                          required={dataForm.password.validation.required}
                          isinvalid={!dataForm.password.valid}
                          isShowPasswordStrengthMeter={true}
                          invalidReason={dataForm.password.invalidReason}
                          touched={dataForm.password.touched}
                          value={dataForm.password.value}
                          isRightIcon={true}
                          rightIcon={GetIcon("eye")}
                          onClickRightIcon={() =>
                            this.onClickRightIcon(dataForm.password.key)
                          }
                          size={"lg"}
                          margin={"m-t-0"}
                          label={dataForm.password.label}
                          changed={(event) =>
                            this.inputHandleChange(event, dataForm.password.key)
                          }
                        />
                        <Input
                          elementConfig={dataForm.confirmPassword.elementConfig}
                          elementType={dataForm.confirmPassword.elementType}
                          required={
                            dataForm.confirmPassword.validation.required
                          }
                          isinvalid={!dataForm.confirmPassword.valid}
                          isShowPasswordStrengthMeter={false}
                          invalidReason={dataForm.confirmPassword.invalidReason}
                          touched={dataForm.confirmPassword.touched}
                          value={dataForm.confirmPassword.value}
                          isRightIcon={false}
                          rightIcon={GetIcon("eye")}
                          size={"lg"}
                          margin={"m-t-24"}
                          label={dataForm.confirmPassword.label}
                          changed={(event) =>
                            this.inputHandleChange(
                              event,
                              dataForm.confirmPassword.key
                            )
                          }
                        />
                        {/* <>
                          <div className={"d-flex flex-start mt-3"}>
                            <CheckBox
                              onClick={() =>
                                this.onClickAgreedTermsAndCondition()
                              }
                              isState={this.state.termsAndCondition}
                              icon={<RiCheckLine />}
                              link={"terms and conditions"}
                              text={"I agree to the website"}
                            />
                          </div>
                        </> */}
                      </div>
                    </div>
                  )}

                  {/*------ wizard-4 Mobile no verification  -----------*/}
                  <div className={"join-form-wizard-3"}>
                    {this.state.wizardNo === 1 && (
                      <div className={"data-form-wrapper flex-row "}>
                        <Input
                          elementConfig={dataForm.otpVerification.elementConfig}
                          elementType={dataForm.otpVerification.elementType}
                          required={
                            dataForm.otpVerification.validation.required
                          }
                          isinvalid={!dataForm.otpVerification.valid}
                          isShowPasswordStrengthMeter={false}
                          invalidReason={dataForm.otpVerification.invalidReason}
                          touched={dataForm.otpVerification.touched}
                          value={dataForm.otpVerification.value}
                          isRightIcon={false}
                          rightIcon={GetIcon("eye")}
                          size={"lg"}
                          margin={"m-t-0"}
                          label={dataForm.otpVerification.label}
                          changed={(event) =>
                            this.inputHandleChange(
                              event,
                              dataForm.otpVerification.key
                            )
                          }
                        />

                        <div className={"section-wrapper mt-1"}>
                          <div className={"login-form-OTP-message"}>
                            Code not received ? you can sen it again in
                          </div>
                          <div className={"re-send mt-1"}>
                            <OtpResendTimer
                              numberOfInputs={6}
                              timeInterval={20}
                              displayCountdown={!displayOtpResend}
                              countdownText={"Resend"}
                              onOtpEnter={this.onOtpEnter.bind(this)}
                              onCountdownFinish={this.onCountdownFinish.bind(
                                this
                              )}
                            />
                          </div>
                          {displayOtpResend && (
                            <div
                              className={"re-send link"}
                              onClick={() => {
                                let token = getToken();
                                this.setState({
                                  attempt: ++this.state.attempt,
                                });
                                if (this.state.attempt <= 4) {
                                  this.onOtpResend(
                                    this.state.userData.userId,
                                    dataForm.mobileNo.value,
                                    token
                                  );
                                } else {
                                  openNotification({
                                    title: "Account blocked!",
                                    message: "Your account blocked.",
                                    type: "danger",
                                    container: "top-center",
                                  });
                                  this.props.history.push("/");
                                }
                              }}
                            >
                              Resend
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {wizardNo === 2 && (
                  <div
                    className={
                      "join-form-cta-section d-flex justify-content-center"
                    }
                  >
                    <Button
                      text={wizardNo === 1 ? "Next" : "Update"}
                      type={"dark md"}
                      size={"full-width"}
                      isLoading={isLoading}
                      rightIcon={true}
                      rightIconType={"dark"}
                      reactIcon={<RiArrowRightLine />}
                      onClick={async () => {
                        if (wizardNo === 1) {
                          this.setState({ wizardNo: 2 });
                        } else if (wizardNo === 2) {
                          let validationStatus =
                            await this.updateInputValidationErrors();
                          if (validationStatus) {
                            this.updateUserPassword();
                          }
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className={"login-url-wrap d-flex"}>
              Already have an account ?{" "}
              <div
                className={"link"}
                onClick={() => {
                  this.props.history.push("/sign-in");
                  this.props.onClickCloseOTPVerify();
                }}
              >
                &nbsp; Sign In{" "}
              </div>
            </div>
          </div>
        </div>
        <div className={"filter-bg-1"}>
          <FilterColor_1 />
        </div>
        <div className={"filter-bg-2"}>
          <FilterColor_2 />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loginUserData: state.user.user,
    loginUserToken: state.user.token,
    isLogin: state.user.isLogin,
    isRegister: state.user.isRegister,
    isOTPVerify: state.user.isOTPVerify,
    isUpdateMobileNo: state.updateMobileNoReducer.isUpdateMobileNo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLoginUserDetailsById: (id) => dispatch(user.getLoginUserDetailsById(id)),
    onClickOpenSignUp: () =>
      dispatch({ type: actionTypes.OPEN_SIGN_UP, status: true }),
    onClickCloseSignUp: () =>
      dispatch({ type: actionTypes.CLOSED_SIGN_UP, status: false }),
    onAddLoginUser: (userDara) =>
      dispatch({ type: actionTypes.ADD_LOGIN_USER, loginUser: userDara }),
    onClickCloseSignIn: () =>
      dispatch({ type: actionTypes.CLOSED_SIGN_IN, status: false }),
    onClickOpenOTPVerify: (payload) =>
      dispatch({ type: actionTypes.OPEN_OTP_VERIFY, payload: payload }),
    setUserData: (payload) =>
      dispatch({ type: actionTypes.SET_USER_DATA, user: payload }),
    onClickCloseOTPVerify: () =>
      dispatch({ type: actionTypes.CLOSE_OTP_VERIFY }),
    onClickOpenUpdateMobileNo: () =>
      dispatch({ type: actionTypes.OPEN_UPDATE_MOBILE_NO }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgetPasswordComponent);
